<app-alert type='warning' [closable]='false'>
  Wyrysuj obszar następnie kliknij zatwierdź
</app-alert>
<div class='map-wrapper' [ngClass]='{ invalid: getInvalid(), pending: pending }'>
  <div id='map' class='draw-map'></div>
  <app-spinner></app-spinner>
</div>
